import { render, staticRenderFns } from "./minute.vue?vue&type=template&id=d6d0ddfe&"
import script from "./minute.vue?vue&type=script&lang=js&"
export * from "./minute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports